// Sdílené přihlášení webu, portálu a aplikací (rozhodnutí uživatele 2026-11-01).
// Supabase ukládá relaci do úložiště prohlížeče, které má každá adresa zvlášť.
// Na doménách *.bozp-software.cz ji proto ukládáme do cookie pro celou doménu
// (.bozp-software.cz) — vidí ji web, portál i audit.bozp-software.cz, test
// dev.bozp-software.cz i dev.audit.bozp-software.cz. Jinde (netlify.app,
// localhost, testy) zůstává localStorage. Stejný soubor má portál
// (bozp-portal: src/auth-cookie.js) — při změně upravit oba.
//
// Cookie má limit ~4 kB, relace je větší → ukládá se po částech
// <klíč>.0, <klíč>.1 … a počet částí v <klíč>.n.

export const COOKIE_DOMAIN = /(^|\.)bozp-software\.cz$/.test(location.hostname) ? '.bozp-software.cz' : '';
const CHUNK = 3800; // znaků už zakódované hodnoty (limit cookie je 4096 bajtů i s názvem)
const MAX_AGE = 400 * 86400; // nejdelší doba, kterou prohlížeče dovolí

// Hodnoty se ukládají už zakódované (encodeURIComponent celé relace), části
// se dělí podle zakódované délky — čeština a uvozovky zabírají až 9 znaků.
function readCookie(name) {
  const prefix = name + '=';
  const hit = document.cookie.split('; ').find((c) => c.indexOf(prefix) === 0);
  return hit ? hit.slice(prefix.length) : null;
}
function writeCookie(name, encoded, maxAge) {
  let s = name + '=' + encoded + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  if (location.protocol === 'https:') s += '; Secure';
  if (COOKIE_DOMAIN) s += '; domain=' + COOKIE_DOMAIN;
  document.cookie = s;
}

export const cookieStorage = {
  getItem(key) {
    const n = parseInt(readCookie(key + '.n'), 10);
    if (!(n > 0)) return null;
    let out = '';
    for (let i = 0; i < n; i++) {
      const part = readCookie(key + '.' + i);
      if (part == null) return null;
      out += part;
    }
    try { return decodeURIComponent(out); } catch (e) { return null; }
  },
  setItem(key, value) {
    const enc = encodeURIComponent(String(value));
    const old = parseInt(readCookie(key + '.n'), 10) || 0;
    const parts = [];
    for (let i = 0; i < enc.length;) {
      let end = Math.min(i + CHUNK, enc.length);
      // nerozdělit sekvenci %XX
      if (enc[end - 1] === '%') end -= 1; else if (enc[end - 2] === '%') end -= 2;
      parts.push(enc.slice(i, end));
      i = end;
    }
    parts.forEach((p, i) => writeCookie(key + '.' + i, p, MAX_AGE));
    writeCookie(key + '.n', String(parts.length), MAX_AGE);
    for (let i = parts.length; i < old; i++) writeCookie(key + '.' + i, '', 0);
  },
  removeItem(key) {
    const n = parseInt(readCookie(key + '.n'), 10) || 0;
    for (let i = 0; i < n; i++) writeCookie(key + '.' + i, '', 0);
    writeCookie(key + '.n', '', 0);
  },
};

// Úložiště pro createClient: cookie na doménách bozp-software.cz, jinak výchozí.
export function authStorage() {
  return COOKIE_DOMAIN ? cookieStorage : undefined;
}

// Klíč relace Supabase (sb-<projekt>-auth-token).
export const AUTH_KEY = 'sb-irsnrptiazbnnvogjqsv-auth-token';

// Přechod na sdílené přihlášení: kdo byl v Auditu přihlášený dřív (relace
// v localStorage), toho přeneseme do cookie, aby se nemusel přihlašovat znovu.
export function migrateLocalSession() {
  if (!COOKIE_DOMAIN) return;
  try {
    const old = localStorage.getItem(AUTH_KEY);
    if (old && !cookieStorage.getItem(AUTH_KEY)) cookieStorage.setItem(AUTH_KEY, old);
    if (old) localStorage.removeItem(AUTH_KEY);
  } catch (e) {}
}
